(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/redux-localstorage/assets/javascript/localstorage.js') >= 0) return;  svs.modules.push('/components/app/redux-localstorage/assets/javascript/localstorage.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


svs.app = svs.app || {};
svs.app.redux = svs.app.redux || {};
svs.app.ReduxLocalStorage = options => {
  const defaultOptions = {
    key: 'state',
    states: [],
    debounce: 0,
    expires: 0,
    pathDelimiter: '.',
    personalize: false,
    handleAction: null,
    saveStrategy: (data, options) => (options.personalize ? svs.components.personalized_storage : svs.components.Storage.browser).set(options.key, options.domain, data, options.expires),
    loadStrategy: options => (options.personalize ? svs.components.personalized_storage : svs.components.Storage.browser).get(options.key, options.domain),
    clearStrategy: options => svs.components.Storage.browser.remove(options.key, options.domain)
  };
  let debounceTimeout = null;
  if (!options.domain) {
    throw new Error('ReduxLocalStorage is missing required domain option');
  }
  options = _objectSpread(_objectSpread({}, defaultOptions), options);
  function beforeSave(store) {
    const {
      states,
      saveStrategy,
      pathDelimiter
    } = options;
    if (states.length === 0) {
      saveStrategy(store.getState(), options);
    } else {
      const currentState = store.getState();
      const stateToSave = {};
      states.forEach(key => {
        const path = key.split(pathDelimiter);
        if (hasStateValue(path, currentState)) {
          updateStateToSave(path, currentState, stateToSave);
        }
      });
      saveStrategy(stateToSave, options);
    }
  }
  function hasStateValue(path, state) {
    const [key, ...remainingPath] = path;
    if (state[key] === undefined) {
      return false;
    }
    return remainingPath.length ? hasStateValue(remainingPath, state[key]) : true;
  }
  function updateStateToSave(path, currentState, stateToSave) {
    const [key, ...remainingPath] = path;
    if (remainingPath.length) {
      stateToSave[key] = {};
    } else {
      stateToSave[key] = currentState[key];
      return;
    }
    return updateStateToSave(remainingPath, currentState[key], stateToSave[key]);
  }
  return {
    middleware() {
      return store => next => action => {
        const {
          debounce
        } = options;
        const returnValue = next(action);
        if (typeof action === 'object') {
          action = typeof options.handleAction === 'function' ? options.handleAction(action) : action;
          if (!action) {
            return;
          }
          if (debounce) {
            if (debounceTimeout) {
              clearTimeout(debounceTimeout);
            }
            debounceTimeout = setTimeout(() => {
              beforeSave(store);
            }, debounce);
          } else {
            beforeSave(store);
          }
          return returnValue;
        }
      };
    },
    load() {
      return options.loadStrategy(options);
    },
    clear() {
      options.clearStrategy(options);
    }
  };
};

 })(window);